export var dialogActionsDefaultTheme = {
  Root: {
    base: {
      padding: 6,
      ':not(:first-child)': {
        paddingTop: 12
      },
      '& > *:not(:last-child)': {
        marginRight: 4
      }
    }
  }
};